export const CODE_SIZE = 5
export const initialCodeArray = Array(CODE_SIZE).fill("")
